<db-dialog-wrapper [dialog]="this" [width]="'783px'" [height]="'375px'" [fullScreen]="isMobile" [canClose]="!loading" [hasCloseButton]="!loading" [canCloseByBackdrop]="!loading">
  <div class="add-redirects-general">
    <h1 *ngIf="!redirect?.redirectFrom">{{ 'text_emptyRedirectsTitle' | dbText }}</h1>
    <h1 *ngIf="redirect?.redirectFrom">{{ 'text_editRedirectsTitle' | dbText }}</h1>
    <form class="" [formGroup]="addRedirectForm">

      <div class="add-redirects-section">
        <div class="add-redirect-item-wrap status">
          <div class="label">{{'text_status' | dbText}}</div>
          <div class="input status-input sl-statuses">
            <db-fc-dropdown-select class="select-component" [formControl]="status" [value]="status?.value" [options]="statusOptions"></db-fc-dropdown-select>
          </div>
        </div>
        <div class="add-redirect-item-wrap domains"  [ngClass]="{'has-value': redirect?.redirectFrom}">
          <div class="label">{{'text_hosting.domains' | dbText}}</div>
          <div class="input sl-domains">
            <db-fc-dropdown-select  *ngIf="domainsOptions && domainsOptions.length" class="select-component" [formControl]="domains" [value]="domains.value" [options]="domainsOptions"></db-fc-dropdown-select>
          </div>
        </div>
      </div>
      <div class="add-redirects-section">
        <div class="add-redirect-item-wrap">
          <div class="label">{{'text_redirectFrom' | dbText}}</div>
          <div class="input">
            <div>
              <input formControlName="redirectFrom" maxlength="500" placeholder="/oldpath" class="db-fc-input" [value]="redirect?.redirectFrom" [style.border-color]="(addRedirectForm.controls['redirectFrom'].invalid && formSubmitted) ? '#E95E5B' : null"/>
            </div>
            <div class="db-server-error-wrap" *ngIf="serverErrors || (addRedirectForm.controls['redirectFrom'].invalid && addRedirectForm.controls['redirectTo'].touched)">
              <div *ngIf="addRedirectForm.controls['redirectFrom'].invalid && ((addRedirectForm.controls['redirectFrom'].touched && !addRedirectForm.controls['redirectFrom'].errors['required']) || formSubmitted)">{{'text_invalidRedirectFrom' | dbText}}</div>
              <div *ngIf="serverErrors && serverErrors.fields.redirectFrom">{{serverErrors.fields.redirectFrom[0]}}</div>
              <div *ngIf="serverErrors && !hasServerFieldErrors">{{serverErrors.message}}</div>
              <div *ngIf="serverErrorsMessage">{{serverErrorsMessage}}</div>
            </div>
          </div>
        </div>
        <div class="add-redirect-item-wrap">
          <div class="label" >{{'text_redirectTo' | dbText}}</div>
          <div class="input">
            <div>
              <input formControlName="redirectTo" maxlength="500" placeholder="https://redirectto.com/..." class="db-fc-input" [value]="redirect?.redirectTo" [style.border-color]="(addRedirectForm.controls['redirectTo'].invalid && formSubmitted) ? '#E95E5B' : null"/>
            </div>
            <div class="db-server-error-wrap" *ngIf="serverErrors || (addRedirectForm.controls['redirectFrom'].invalid && addRedirectForm.controls['redirectTo'].touched) || isRedirectToHostname()">
              <div *ngIf="(addRedirectForm.controls['redirectTo'].invalid && ((addRedirectForm.controls['redirectTo'].touched && !addRedirectForm.controls['redirectTo'].errors['required']) || formSubmitted))">{{'text_invalidRedirectFrom' | dbText}}</div>
              <div *ngIf="serverErrors && serverErrors.fields['redirectTo']">{{serverErrors.fields.redirectTo[0]}}</div>
              <div *ngIf="isRedirectToHostname()" class="db-server-error">Redirects to our subdomains are not allowed.</div>
            </div>
          </div>
        </div>
      </div>
      <div class="add-redirect-item-wrap add-redirects-section add-redirects-buttons">
        <a class="ds-btn" (click)="cancel()" [ngClass]="{'ds-btn-disabled': loading}"><span>{{"text_cancel" | dbText}}</span></a>
        <a (click)="onFormSubmit()" class="ds-btn-blue" [ngClass]="{'ds-btn-disabled': isSubmitDisabled()}">
          <span *ngIf="!loading">{{(redirect ? 'text_updateRedirect' : 'text_addRedirect') | dbText}}</span>
          <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        </a>
      </div>
    </form>
  </div>
</db-dialog-wrapper>
